import React from 'react'
import { Link, useNavigate } from 'react-router'
import { useAuth } from '../contexts/AuthContext'
import XosaWordmark from './brand/XosaWordmark'
import HeaderSearch from './header/HeaderSearch'
import HeaderUserMenu from './header/HeaderUserMenu'
import NotificationBell from './notifications/NotificationBell'
import { Container } from './ui'

/**
 * Editorial header — wordmark left; icon toolbar right (search, notifications, account).
 */
const Header: React.FC = () => {
  const navigate = useNavigate()
  const { user, logout } = useAuth()

  async function handleLogout() {
    await logout()
    navigate('/login', { replace: true })
  }

  const homeTo = user ? '/' : '/login'

  return (
    <header className="bg-paper border-b border-rule">
      <Container>
        <div className="flex justify-between items-center h-14">
          <Link
            to={homeTo}
            className="hover:opacity-80 transition-opacity"
            aria-label="Forside"
          >
            <XosaWordmark />
          </Link>

          {user && (
            <nav
              aria-label="Hovednavigation"
              className="flex items-center gap-1 sm:gap-2"
            >
              <HeaderSearch />
              <NotificationBell />
              <div
                className="h-5 w-px bg-rule mx-1 sm:mx-2 shrink-0"
                aria-hidden
              />
              <HeaderUserMenu name={user.name} onLogout={handleLogout} />
            </nav>
          )}
        </div>
      </Container>
    </header>
  )
}

export default Header
